module.exports = __webpack_public_path__ + "img/03-1.b5a5c616.png";